export const EstadoTarea = {
    pendiente: "PENDIENTE",
    error: "INVALIDO",
    validar: "VALIDAR",
    rechazo: "DATOS_INVALIDOS",
    aprobado: "APROBADO",
};

export const EstadosTarea = [
    "PENDIENTE",
    "INVALIDO",
    "RECHAZADO",
    "APROBADO"
];

export const EstadosDocumentos = [
    "RECIBIDO VERIFICACION",
    "DOCUMENTOS_ENVIADOS_SAT",
    "DOCUMENTOS_ENVIADOS_APROBACION",
    "ANULADO USUARIO",
    "RECHAZADO",
    "INVALIDO",
    "APROBADO",
    "PENDIENTE",
    "BORRADO"
];



export const TiposTramite = ["FÍSICO","VIRTUAL"];


// WEBPACK FOOTER //
// ./src/co/sura/dominio/bandeja/modelo/EstadosTarea.ts